// extracted by mini-css-extract-plugin
export default {"fullStatementBox":"FullStatementBox_fullStatementBox__DNCrF","closeButton":"FullStatementBox_closeButton__MLt07","textContainer":"FullStatementBox_textContainer__etLoC"};